import React from 'react';
import { CloudIcon, PencilIcon, ShoppingCartIcon, ThumbsUpIcon } from 'lucide-react';
import { FormlabsLogo, PreFormIcon } from '../icons/ToolIcons';
export function TopNav() {
  return <header className="relative flex h-[38px] shrink-0 items-stretch bg-pf-nav text-white" data-id="element-74" data-mp="38ml09xzjcom6">
      <div className="flex w-[38px] items-center justify-center" data-id="element-75" data-mp="3cnepqvsmmbh6">
        <FormlabsLogo className="h-[16px] w-[22px] text-white" data-id="element-76" data-mp="3clk2hatvu79x" />
      </div>
      <nav aria-label="App sections" className="flex items-stretch" data-id="element-77" data-mp="2yn3snb0q40nk">
        <a href="#" aria-current="page" className="flex items-center gap-[8px] border-b-[2px] border-[#2f86f0] bg-pf-nav-active px-[14px] text-[12.5px]" data-id="element-78" data-mp="33n8elgkehnl6">
          <PreFormIcon className="h-[17px] w-[17px]" data-id="element-79" data-mp="2ppa44m97abay" />
          PreForm
        </a>
        <a href="#" className="flex items-center gap-[8px] px-[14px] text-[12.5px] text-[#d8dbdf] transition-colors duration-150 hover:bg-white/5 hover:text-white" data-id="element-80" data-mp="2tp2e93e8spif">
          <CloudIcon className="h-[16px] w-[16px]" strokeWidth={1.6} data-id="element-81" data-mp="rxp7e8sps7jq" />
          Dashboard
        </a>
      </nav>

      <div className="pointer-events-none absolute inset-y-0 left-0 right-[232px] flex items-center justify-center" data-id="element-82" data-mp="1vdilny69hlxj">
        <button type="button" className="pointer-events-auto flex items-center gap-[8px] text-[12px] text-[#e9ebee] hover:text-white" data-id="element-83" data-mp="1qfgs2jb7m47t">
          Mini Chassis Kit
          <PencilIcon className="h-[11px] w-[11px]" strokeWidth={2.4} data-id="element-84" data-mp="205a39j7fwhbj" />
        </button>
      </div>

      <div className="ml-auto flex items-center gap-[22px] pr-[22px]" data-id="element-85" data-mp="1cf61zihq4tnp">
        <button type="button" aria-label="Send feedback" className="text-white/90 hover:text-white" data-id="element-86" data-mp="17h4gys0qmk9l">
          <ThumbsUpIcon className="h-[15px] w-[15px]" fill="currentColor" strokeWidth={1.5} data-id="element-87" data-mp="1mdvk9cdj8g4h" />
        </button>
        <button type="button" aria-label="Formlabs store" className="text-white/90 hover:text-white" data-id="element-88" data-mp="1heivun70j0zs">
          <ShoppingCartIcon className="h-[15px] w-[15px]" fill="currentColor" strokeWidth={1.5} data-id="element-89" data-mp="2xssj1dziqjp1" />
        </button>
      </div>

      <button type="button" className="flex w-[232px] items-center gap-[8px] border-l border-[#46505c] px-[12px] text-left transition-colors duration-150 hover:bg-white/5" data-id="element-90" data-mp="2stfp69a8cccy">
        <span className="flex h-[20px] w-[20px] items-center justify-center rounded-full bg-[#1f6fd6] text-[8px] font-bold" data-id="element-91" data-mp="34vpdekp712uc">AJ</span>
        <span className="flex-1 leading-[1.15]" data-id="element-92" data-mp="39w4n92a9ns7k">
          <span className="block text-[10px] font-bold" data-id="element-93" data-mp="3euejlg7q8yur">Armin Jamak</span>
          <span className="block text-[10px] text-[#d8dbdf]" data-id="element-94" data-mp="3esbx365s9nus">jamakarmin@gmail.com</span>
        </span>
        <svg viewBox="0 0 5 8" className="h-[7px] w-[5px]" fill="currentColor" aria-hidden="true" data-id="element-95" data-mp="2h533sozjjai8">
          <path d="M0 0 L5 4 L0 8 Z" data-id="element-96" data-mp="2m3o4sqmm9y7q" />
        </svg>
      </button>
    </header>;
}